/**
 * 把網址拆成 `origin`（? 之前）、`query`（第一個 ? 到 # 之間）、`hash`（第一個 # 起、含 #）。
 *
 * 不能用 `String.split`：URL 的結構分隔符只有「第一次出現」算數 ——
 * query 值裡合法出現的第二個 `?`（如 `?redirect=/page?id=3`）與 fragment
 * 都會被 `split('?')` 切碎丟失。
 */
const splitUrl = (url: string) => {
  const hashIndex = url.indexOf('#')
  const beforeHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : ''

  const queryIndex = beforeHash.indexOf('?')
  const origin = queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash
  const query = queryIndex >= 0 ? beforeHash.slice(queryIndex + 1) : ''

  return { origin, query, hash }
}

export default splitUrl
